import { captureMessage } from '@sentry/nextjs';
import { useEffect } from 'react';

/**
 * This hook is used to report scam websites to sentry.
 * This was added during SS24, to report scam websites to Sentry
 * Websites where using our source code (SSR) and trying to scam users.
 * Appropriate action was to report the website to google to take it down.
 *
 */
export const useReportScamSite = () => {
  useEffect(() => {
    if (window.location.host.endsWith('nofomo.com')) return;

    // report to sentry
    captureMessage(
      '[SCAM-WEBSITE] - Please check the domain: ' + window.location.host,
    );
  }, []);
};
